export default __webpack_public_path__ + "static/media/jose-serafim.e184e09f.jpg";